import React from 'react';
import './simple_page.css';

const ConfirmRegistration = () => {


    return (
        <div className="todoqu-simple-text">
            <h3>Account activated!</h3>
            <h3>You many now log in.</h3>
        </div>
    );
}

export default ConfirmRegistration;